// API configuration and constants
// export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://localhost:3001';
export const API_BASE_URL = 'https://families.forkodes.com'; // Default to production URL if not set

export const API_PREFIX = '/api';

export const API_ENDPOINTS = {
    // Health check
    HEALTH: '/health',

    // Authentication
    AUTH: {
        REGISTER: `${API_PREFIX}/auth/register`,
        WEBSITE_TOKEN: `${API_PREFIX}/auth/website-token`,
        GET_USER_BY_SLUG: `${API_PREFIX}/auth/user/:slug`,
    },

    // Family Trees
    FAMILY_TREES: {
        GET: `${API_PREFIX}/family-tree/:slug`,
        GET_MEMBER: `${API_PREFIX}/family-tree/:treeSlug/member/:memberId`,
    },

    // Members
    MEMBERS: {
        CREATE: `${API_PREFIX}/family-tree/:treeSlug/member`,
        UPDATE: `${API_PREFIX}/family-tree/:treeSlug/member/:memberId`,
        DELETE: `${API_PREFIX}/family-tree/:treeSlug/member/:memberId`,
    },

    // Images
    IMAGES: {
        ADD: `${API_PREFIX}/family-tree/:treeSlug/member/:memberId/images`,
    },

    // Relationships
    RELATIONSHIPS: {
        CREATE: `${API_PREFIX}/family-tree/:treeSlug/relationship`,
    },
};

export const WEBSITE_TOKEN_KEY = 'family_tree_website_token';

// HTTP Methods
export const HTTP_METHODS = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    PATCH: 'PATCH',
    DELETE: 'DELETE',
};

// Default request timeout (30 seconds)
export const REQUEST_TIMEOUT = 30000;
